import Select from "react-select";
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 1, label:  "Todos" },
    { value: 2, label:  "Ontem" },
    { value: 3, label:  "Hoje" },
    { value: 4, label:  "Amanhã" },
    { value: 5, label:  "Esta semana" },
    { value: 6, label:  "Semana que vem" },
    { value: 7, label:  "Semana passada" },
    { value: 8, label:  "Este mês" },
    { value: 9, label:  "Mês que vem" },
    { value: 10, label:  "Mês passado" },
    { value: 11, label:  "Este ano" },
    { value: 12, label:  "Ano que vem" },
    { value: 13, label:  "Ano passado" },
    { value: 14, label:  "Personalizado" },
];

const PeriodoDatas = ({ field, placeholder, name, id, disabled=false, onKeyDown }) => {
    return (
        <Select 
            options={options}
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
            onKeyDown={onKeyDown}
        />
    )
}

export { PeriodoDatas, options as OpcoesPeriodoDatas }